import Vue from 'vue';
import Router from 'vue-router';

import Layout from '@/pages/Layout';
import Login from '@/pages/Login';
import Projects from '@/pages/Projects';
import Diaries from '@/pages/Diaries';
import Diary from '@/pages/Diary';
import Customers from '@/pages/Customers';
import Inspectors from '@/pages/Inspectors';
import Observers from '@/pages/Observers';
import Contractors from '@/pages/Contractors';
import Entrepreneurs from '@/pages/Entrepreneurs';
import Users from '@/pages/Users';
import Reports from '@/pages/Reports';
import Settings from '@/pages/Settings';
import MyAccount from '@/pages/MyAccount';
import Messages from '@/pages/Messages';
import Plans from '@/pages/Plans';
import Plan from '@/pages/Plan';


Vue.use(Router);

export default new Router({
    //mode: 'history',
    routes: [
        {
            path: '/',
            component: Layout,
            children: [{ path: '', name: 'Diaries', component: Diaries }]
        },
        {
            path: '/MyAccount',
            component: Layout,
            children: [{ path: '', name: 'MyAccount', component: MyAccount }]
        },
        {
            path: '/Plans',
            component: Layout,
            children: [{ path: '', name: 'Plans', component: Plans }]
        },
        {
            path: '/Plan/:planKey',
            name: 'Plan',
            component: Plan,
        },
        {
            path: '/Diary/:diaryKey',
            name: 'Diary',
            component: Diary,
        },
        {
            path: '/Projects',
            component: Layout,
            children: [{ path: '', name: 'Projects', component: Projects }]
        },
        {
            path: '/Customers',
            component: Layout,
            children: [{ path: '', name: 'Customers', component: Customers }]
        },
        {
            path: '/Contractors',
            component: Layout,
            children: [{ path: '', name: 'Contractors', component: Contractors }]
        },
        {
            path: '/Inspectors',
            component: Layout,
            children: [{ path: '', name: 'Inspectors', component: Inspectors }]
        },
        {
            path: '/Observers',
            component: Layout,
            children: [{ path: '', name: 'Observers', component: Observers }]
        },
        {
            path: '/Entrepreneurs',
            component: Layout,
            children: [{ path: '', name: 'Entrepreneurs', component: Entrepreneurs }]
        },
        {
            path: '/Users',
            component: Layout,
            children: [{ path: '', name: 'Users', component: Users }]
        },
        {
            path: '/Reports',
            component: Layout,
            children: [{ path: '', name: 'Reports', component: Reports }]
        },
        {
            path: '/Settings',
            component: Layout,
            children: [{ path: '', name: 'Settings', component: Settings }]
        },
        {
            path: '/Messages',
            component: Layout,
            children: [{ path: '', name: 'Messages', component: Messages }]
        },
        {
            path: '/Login',
            name: 'Login',
            component: Login,
        },
    ]
});



// WEBPACK FOOTER //
// ./src/routes/index.js